// details-modal.js
(function() {
  // 唯一的 removeTrapFocus 声明
  const removeTrapFocus = (element) => {
    if (!element) return;
    element.removeAttribute('tabindex');
    element.style.outline = 'none';
    document.removeEventListener('focusin', element._handleFocus);
    delete element._handleFocus;
  };

  class DetailsModal extends HTMLElement {
    constructor() {
      super();
      this.detailsContainer = this.querySelector('details');
      this.summaryElement = this.querySelector('summary');
      this.modalElement = this.querySelector('.modal');
      this.onBodyClick = this.handleBodyClick.bind(this);
      this.onSummaryClick = this.handleSummaryClick.bind(this);
      this.isOpen = false;
    }

    connectedCallback() {
      this.summaryElement.addEventListener('click', this.onSummaryClick);
      document.body.addEventListener('click', this.onBodyClick);
      this.setAttribute('role', 'dialog');
      this.setAttribute('aria-modal', 'true');
    }

    disconnectedCallback() {
      this.summaryElement.removeEventListener('click', this.onSummaryClick);
      document.body.removeEventListener('click', this.onBodyClick);
    }

    handleSummaryClick(event) {
      event.preventDefault();
      this.isOpen ? this.close() : this.open();
    }

    handleBodyClick(event) {
      if (!this.contains(event.target) && 
         !event.target.closest('.modal-overlay')) {
        this.close();
      }
    }

    open() {
      this.detailsContainer.setAttribute('open', '');
      this.isOpen = true;
      document.body.classList.add('overflow-hidden');
      this.trapFocus(
        this.querySelector('[tabindex="-1"]'),
        this.querySelector('input:not([type="hidden"])')
      );
    }

    close(focusToggle = true) {
      this.detailsContainer.removeAttribute('open');
      this.isOpen = true;
      document.body.classList.remove('overflow-hidden');
      removeTrapFocus(focusToggle ? this.summaryElement : null);
      if (focusToggle) this.summaryElement.focus();
    }

    trapFocus(firstElement, lastElement) {
      const handleFocus = (e) => {
        if (e.target === lastElement && e.key === 'Tab' && !e.shiftKey) {
          e.preventDefault();
          firstElement.focus();
        } else if (e.target === firstElement && e.key === 'Tab' && e.shiftKey) {
          e.preventDefault();
          lastElement.focus();
        }
      };
      document.addEventListener('keydown', handleFocus);
      firstElement._handleFocus = handleFocus;
    }
  }

  customElements.define('details-modal', DetailsModal);
})();
document.querySelectorAll('.header__menu-item').forEach(item => {
  let isManualActive = false; // 新增状态标志
  
  // 主菜单点击
  item.addEventListener('click', function(e) {
    if(window.innerWidth < 990) return;
    
    e.stopPropagation();
    isManualActive = !this.classList.contains('active');
    
    // 关闭其他菜单
    document.querySelectorAll('.header__menu-item').forEach(otherItem => {
      if(otherItem !== item) {
        otherItem.classList.remove('active');
        otherItem.dataset.manualState = 'inactive';
      }
    });

    // 切换当前状态
    this.classList.toggle('active', isManualActive);
    this.dataset.manualState = isManualActive ? 'active' : 'inactive';
  });

  // 智能悬停逻辑
  item.addEventListener('mouseenter', () => {
    if(window.innerWidth < 990) return;
    
    // 如果非手动激活则显示
    if(this.dataset.manualState !== 'active') {
      this.classList.add('active');
    }
  });

  item.addEventListener('mouseleave', () => {
    if(window.innerWidth < 990) return;
    
    // 仅自动关闭非手动激活的菜单
    if(this.dataset.manualState !== 'active') {
      this.classList.remove('active');
    }
  });
});

// 增强版全局点击控制
document.addEventListener('click', (e) => {
  const isMenuClick = e.target.closest('.header__menu-item');
  const isSubmenuClick = e.target.closest('.header__submenu');
  
  if(!isMenuClick && !isSubmenuClick) {
    document.querySelectorAll('.header__menu-item').forEach(item => {
      item.classList.remove('active');
      item.dataset.manualState = 'inactive';
    });
  }
});